module.exports = __webpack_public_path__ + "img/search-yellow.21a37071.svg";